module.exports = require('./helpers/bundle-url').getBundleURL('6bQWm') + "logo.c51670a8.svg";